import { render, staticRenderFns } from "./ItemTransactions.vue?vue&type=template&id=2a6e38e3&scoped=true"
import script from "./ItemTransactions.vue?vue&type=script&lang=js"
export * from "./ItemTransactions.vue?vue&type=script&lang=js"
import style0 from "./ItemTransactions.vue?vue&type=style&index=0&id=2a6e38e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e38e3",
  null
  
)

export default component.exports